import { useRef } from "react";
import ClubCarousel from "../../../components/ClubCarousel/ClubCarousel";
import HeadPage from "../../../components/HeadPage/HeadPage";
import Steps from "../../../components/Steps/Steps";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import { ApplicationContextProvider } from "../../../context/ApplicationContext";
import CardCarousel from "../../../components/CardCarousel/CardCarousel";
import { fetchData } from "../../../fetcher";
import styles from "../../../styles/pages/the-mall-club.module.scss";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";

const TheMallClub = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null);
  return (
    <div className="transparent">
      <TheMallOutletLayout menuItems={menuItems}>
        <HeadPage
          {...dataContent?.layouts.head.data.blocks}
          scrollToRef={scrollToRef}
        />
        <div className={styles.theMallClub} ref={scrollToRef}>
          {dataContent?.layouts?.intro?.data && (
            <div className={styles.intro}>
              <div style={{ maxWidth: "890px", margin: "auto" }} dangerouslySetInnerHTML={{ __html: dataContent.layouts.intro.data.blocks.intro }}></div>
              <div className={styles.introTitle}>
                {dataContent.layouts.intro.data.blocks.title}
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: dataContent.layouts.intro.data.blocks.text,
                }}
              ></div>
            </div>
          )}
          <div className={styles.Steps}>
            <Steps {...dataContent?.layouts.steps.data.blocks} />
          </div>
        </div>
        <ClubCarousel
          title={dataContent?.layouts.clubCarousel.data.blocks.title}
          navigation={
            dataContent?.layouts.clubCarousel.data.blocks.navigation
          }
          slides={dataContent?.layouts.clubCarousel.data.blocks.slides}
          rules={dataContent?.layouts.clubRules.data}
          bigger
          note={dataContent?.layouts.clubCarousel.data.blocks.note}
        />
        <div className="scroll">
          <ScrollDown selector={scrollToRef} scrollTop />
        </div>
      </TheMallOutletLayout>
    </div>
  );
};

TheMallClub.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
  };
};

export default TheMallClub;
